/**
 * @desc 获取BPM系统的用户角色的待办任务
 */
const URL = "/rantion-activiti";
import http, { updateResponse } from "@/http";
export type Response = defs.activiti.Response;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/bpm/dumpTaskList`, {
      method: "GET",

      ...options,
    }),
  );
}
